<template>
    <div class="attend-scan-view">
        <div class="attend-actions" v-if="isConnected">
            <v-btn @click="scanAttend" x-large color="primary" :loading="isScanning" :disabled="isScanning">Escanear {{
                matchError || matchedEmp ? 'Otra' : ''
                }}
                Huella</v-btn>

            <v-card class="mt-5">
                <v-card-text class="d-flex flex-column align-center">
                    <battery-level :battery-percentage="deviceBattery" />
                    <span class="text-p mt-4">Dispositivo: {{ deviceName }}</span>
                </v-card-text>
            </v-card>
        </div>
        <div class="attend-actions" v-else>
            <v-btn @click="connectDevice" x-large color="primary" :disabled="isConnecting"
                :loading="isConnecting">Connectar Dispositivo</v-btn>
        </div>
        <div class="result-container">
            <v-card v-if="matchedEmp">
                <v-card-text class="d-flex flex-column align-center">
                    <v-row class="d-flex align-center justify-center">
                        <v-col cols="auto">
                            <v-icon x-large color="success">mdi-check-circle</v-icon>
                        </v-col>
                        <v-col cols="auto">
                            <span class="font-weight-medium text-h6">
                                Empleado encontrado
                            </span>
                        </v-col>
                    </v-row>
                    <v-img class="mb-8 mt-2" :width="150" cover
                        :src="matchedEmp.img || require('@/assets/imgs/no-img21.png')" />
                    <p class="text-h5">{{ matchedEmp.name }}</p>
                </v-card-text>
            </v-card>
            <v-card v-else-if="matchError">
                <v-card-text class="d-flex flex-column align-center">
                    <v-icon x-large color="error">
                        mdi-alert-circle
                    </v-icon>
                    <p class="font-weight-medium text-h6">{{ matchError }}</p>
                </v-card-text>
            </v-card>
            <v-card v-else>
                <v-card-text class="d-flex flex-column align-center">
                    <v-progress-circular x-large v-if="isConnecting || isScanning" indeterminate color="primary"
                        class="my-5"></v-progress-circular>
                    <p class="font-weight-bold text-h5 text-center">{{ title }}</p>
                    <p class="font-weight-medium">{{ message }}</p>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>
<script>

import AttendTable from '@/components/Tables/AttendTable';
import { matchTemplates } from '../services/fp-service/matcher';
import { mapGetters } from 'vuex';
import BatteryLevel from '../components/Misc/BatteryLevel.vue';
export default {
    components: {
        AttendTable,
        BatteryLevel
    },
    data() {
        return {
            isMatching: false,
            matchedEmpId: null,
            matchError: null,
        }
    },
    created() {
        this.loadFps();
        this.loadActiveEmps();
    },
    destroyed() {
        this.$store.dispatch('disconnectDevice');
    },
    methods: {
        loadFps() {
            this.$store.dispatch({ type: 'loadFps', });
        },
        loadActiveEmps() {
            this.$store.dispatch({ type: 'loadActiveEmps' });
        },
        async scanAttend() {
            this.matchError = null;
            this.matchedEmpId = null;
            const data = await this.$store.dispatch('captureFp');
            this.matchFp(data);
        },
        connectDevice() {
            return this.$store.dispatch('connectDevice');
        },
        async addAttend(empId) {
            await this.$store.dispatch('updateEmpAttendByDate', { empId, date: new Date() });
        },
        async matchFp(data) {
            this.isMatching = true;
            for (const fp of this.fps) {
                const score = matchTemplates(
                    fp.data,
                    data,
                )
                if (score > 20) {
                    this.isMatching = false;
                    this.matchedEmpId = fp.empId;
                    this.addAttend(fp.empId);
                    return;
                }
            }

            this.isMatching = false;
            this.matchError = 'No se encontró el empleado';
        },
    },
    computed: {
        ...mapGetters(['activeEmps', 'fps', 'isScanning', 'isConnected', 'isConnecting', 'isChoosingDevice', 'deviceBattery', 'deviceName']),
        matchedEmp() {
            if (!this.matchedEmpId || !this.activeEmps) return null;
            return this.activeEmps.find(emp => emp._id === this.matchedEmpId);
        },
        title() {
            if (this.isConnecting) {
                return 'Conectando dispositivo por favor espere'
            }
            if (this.isChoosingDevice) {
                return 'Elija el dispositivo cuyo nombre comience con "IBS"'
            }
            if (!this.isConnected) {
                return 'Conecte el lector de huellas'
            }
            if (this.isScanning) {
                return 'Escaneando huella'
            }
            if (this.isMatching) {
                return 'Verificando huella'
            }
            return 'Listo para escanear'

        },
        message() {
            if (this.isChoosingDevice) {
                return ''
            }
            if (!this.isConnected) {
                return 'Encienda el lector de huellas y haga clic en el botón Conectar'
            }
            if (this.isScanning) {
                return 'Por favor, coloque su dedo en el lector de huellas'
            }
            if (this.isMatching) {
                return 'Buscando empleado'
            }
            return 'Haga clic en el botón Escanear Huella'
        }
    }
}
</script>

<style></style>